export default __webpack_public_path__ + "static/SEO_fundacja-6fdea05163d0e85f9a27035357f1fc64.jpg";